import React from 'react';
import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { useClubDpCards } from '@/data/Content/ClubDp';
import { LinkCardView } from '@/components/content/Account/parts/ClubDpRewards/LinkCardView';
import { MainCardView } from '@/components/content/Account/parts/ClubDpRewards/MainCardView';

interface ClubDpRewardsProps {
	onMutateClubDpFlags: () => void;
}

export const ClubDpRewards: React.FC<ClubDpRewardsProps> = ({ onMutateClubDpFlags }) => {
	const { cards, loading, cardUnlink } = useClubDpCards();

	if (loading) {
		return <ProgressIndicator />;
	}

	return (
		<React.Fragment>
			{!cards?.rewards ? (
				<LinkCardView />
			) : (
				<MainCardView
					cards={cards}
					loading={loading}
					cardUnlink={cardUnlink}
					onMutateClubDpFlags={onMutateClubDpFlags}
				/>
			)}
		</React.Fragment>
	);
};
